import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdvancedLeakSearchService {
  baseUrl: string = environment.baseUrl;

  constructor(private http: HttpClient) {}

getJobIds(
  type: string,
  searchValues: string[],
  ipAddress: string,
  location: string
): Observable<any> {
  const payload: any = {
    query_type: type,
    query: searchValues[0],
    match_type: 'exact',
    device: 'chrome',
    ip_address: ipAddress,
    location: location
  };

  return this.http.post(`${this.baseUrl}/leak/search`, payload);
}


  getSearchResults(type: string, jobIds: string[]): Observable<any> {
    const url: string = `${this.baseUrl}/leak/job`;
    const params = new HttpParams()
      .set('query_type', type)
      .set('job_id', jobIds[0]);

    return this.http.get(url, { params });
  }

  getCompletedSearchResult(type: string, searchId: string): Observable<any> {
    const url: string = `${this.baseUrl}/leak/results`;
    const params = new HttpParams()
      .set('leak_search_id', searchId)
      .set('type', type);

    return this.http.get(url, { params });
  }

  exportSearchResult(
    type: string,
    searchId: string,
    format: string,
  ): Observable<any> {
    const url: string = `${this.baseUrl}/leak/results`;
    const params = new HttpParams()
      .set('leak_search_id', searchId)
      .set('type', type)
      .set('is_export', true)
      .set('format', format);

    return this.http.get(url, { params });
  }

  updateNotes(resultId: string, payload: any): Observable<any> {
    const params = new HttpParams().set('result_id', resultId);

    return this.http.put(`${this.baseUrl}/leak/update`, payload, { params });
  }
}
